import { QueryResult } from "@apollo/client";
import React from "react";
import { Table, TableColumns } from "../../components/Table";

interface ListViewOptions<TData, TCellData, TVariables> {
  query: QueryResult<TData, TVariables>;
  itemKey: keyof TData;
  loading: JSX.Element;
  error: JSX.Element;
  cols: TableColumns<TCellData>;
}

export const ListView = <TData, TCellData, TVariables = any>(
  props: ListViewOptions<TData, TCellData, TVariables>
) => {
  if (props.query.loading) return props.loading;
  if (props.query.error) return props.error;

  if (props.query.data !== undefined && props.query.data !== null)
    return React.createElement(Table, {
      columns: props.cols as any,
      items: props.query.data[props.itemKey] as any, // Fix this ugly mess xd,
    });

  return props.error;
};
